import { Locale } from '@fixter/i18n';
import { getLinkByKey, getShortTextByKey } from '$cms/getDataByKey';
import type { CmsContentDictionary } from '$cms/index';
import type { MenuItem } from './types';

export const getCmsMenuItems = (cmsData: CmsContentDictionary, locale: Locale): MenuItem[] => {
  const getLink = getLinkByKey.bind(cmsData);
  const getShortText = getShortTextByKey.bind(cmsData);

  switch (locale) {
    case Locale.EN_GB:
      return [
        getLink('navbar.link.mot', {
          text: 'MOT',
          url: '/mot',
        }),
        getLink('navbar.link.carService', {
          text: 'Car service',
          url: '/car-service',
        }),
        {
          title: getShortText('navbar.section.carRepairs', 'Car repairs'),
          links: [
            getLink('navbar.link.timingBelt', {
              text: 'Timing belt',
              url: '/timing-belt-replacement',
            }),
            getLink('navbar.link.diagnoseAndFixProblems', {
              text: 'Diagnose and Fix problems',
              url: '/car-diagnostic',
            }),
            getLink('navbar.link.brakePadsFront', {
              text: 'Brake pads front',
              url: '/brake-pads-replacement',
            }),
            getLink('navbar.link.brakePadsRear', {
              text: 'Brake pads rear',
              url: '/brake-pads-replacement',
            }),
            getLink('navbar.link.seeAllRepairs', {
              text: 'See all repairs',
              url: '/our-services',
            }),
          ],
        },
      ];

    case Locale.FR_FR:
      return [
        getLink('navbar.link.controleTechnique', {
          text: 'Contrôle Technique',
          url: '/controle-technique',
        }),
        getLink('navbar.link.interimService', {
          text: 'Vidange',
          url: '/vidange',
        }),
        getLink('navbar.link.fullService', {
          text: 'Révision',
          url: '/revision',
        }),
        {
          title: getShortText('navbar.section.carRepairs', 'Réparations'),
          links: [
            getLink('navbar.link.brakePadsFront', {
              text: 'Plaquettes de frein',
              url: '/changement-plaquettes-de-frein',
            }),
            getLink('navbar.link.courroieDistribution', {
              text: 'Courroie de distribution',
              url: '/changement-courroie-distribution',
            }),
            getLink('navbar.link.kitEmbrayage', {
              text: "Kit d'embrayage",
              url: '/changement-embrayage',
            }),
            getLink('navbar.link.amortisseurs', {
              text: 'Amortisseurs',
              url: '/changement-amortisseurs',
            }),
            getLink('navBar.link.plaquettesDisquesFrein', {
              text: 'Plaquettes et disques de frein',
              url: '/changement-plaquettes-disques-frein',
            }),
            getLink('navbar.link.rechargeClimatisation', {
              text: 'Recharge de la climatisation',
              url: '/recharge-climatisation',
            }),
            getLink('navBar.link.compresserClimatisation', {
              text: 'Compresseur de climatisation',
              url: '/changement-compresseur-climitisation',
            }),
            getLink('navBar.link.radiator', {
              text: 'Radiateur',
              url: '/changement-radiateur',
            }),
          ],
        },
      ];

    default:
      return [];
  }
};
